import {Circle, Marker, OverlayLoadFunc} from '@/map/modules';
import {Dot} from './Dot';

interface IProps
  extends Omit<naver.maps.CircleOptions, 'center'>,
    OverlayLoadFunc {
  dotSize?: number;
  center?: naver.maps.CircleOptions['center'];
}

export const CircleWithCenterPoint = ({
  map,
  center,
  dotSize,
  ...props
}: IProps) => {
  if (!center) {
    return null;
  }

  const borderColor = props.strokeColor;

  return (
    <>
      <Circle map={map} center={center} {...props} />;
      <Marker map={map} position={center}>
        <Dot borderColor={borderColor} size={dotSize ?? 8} />
      </Marker>
    </>
  );
};
